export const SELECT_MAKE = 'Make';
export const SELECT_MODEL = 'Model';
export const SELECT_YEAR = 'Year';
export const SELECT_COLOR = 'Color';

export const AUTO_TYPE = 'Auto Type';
export const MILEAGE = 'Mileage';

export const RED = 'Red';
export const ORANGE = 'Orange';
export const YELLOW = 'Yellow';
export const WHITE = 'White';
export const BLACK = 'Black';
export const CHARTREUSE = 'Chartreuse';
export const GREEN = 'Green';
export const CYAN = 'Cyan';
export const AZURE = 'Azure';
export const BLUE = 'Blue';
export const VIOLET = 'Violet';
export const MAGENTA = 'Magenta';
export const ROSE = 'Rose';

export const ALL_COLORS = [
  RED,
  ORANGE,
  YELLOW,
  WHITE,
  BLACK,
  CHARTREUSE,
  GREEN,
  CYAN,
  AZURE,
  BLUE,
  VIOLET,
  MAGENTA,
  ROSE,
];

// List of Categories
export const SEDAN = 'Sedan';
export const COUPE = 'Coupe';
export const SUV = 'SUV';
export const CONVERTIBLE = 'Convertible';
export const HATCHBACK = 'Hatchback';
export const PICKUP = 'Pickup';
export const VAN = 'Van';
export const MINIVAN = 'Minivan';
export const WAGON = 'Wagon';

export const ALL_CATEGORIES = [
  SEDAN,
  COUPE,
  SUV,
  CONVERTIBLE,
  HATCHBACK,
  PICKUP,
  VAN,
  MINIVAN,
  WAGON,
];

// List of Car Manufacturers - Makes
export const ACURA = 'Acura';
export const ALFA_ROMEO = 'Alfa_Romeo';
export const ASTON_MARTIN = 'Aston_Martin';
export const AUDI = 'Audi';
export const BMW = 'BMW';
export const BENTLEY = 'Bentley';
export const BUICK = 'Buick';
export const CADILLAC = 'Cadillac';
export const CHEVROLET = 'Chevrolet';
export const CHRYSLER = 'Chrysler';
export const DAEWOO = 'Daewoo';
export const DAIHATSU = 'Daihatsu';
export const DODGE = 'Dodge';
export const EAGLE = 'Eagle';
export const FERRARI = 'Ferrari';
export const FIAT = 'Fiat';
export const FORD = 'Ford';
export const FREIGHTLINER = 'Freightliner';
export const GMC = 'GMC';
export const GENESIS = 'Genesis';
export const GEO = 'Geo';
export const HONDA = 'Honda';
export const HUMMER = 'Hummer';
export const INFINITI = 'Infinity'; // Infinity type on the dataset
export const ISUZU = 'Isuzu';
export const JAGUAR = 'Jaguar';
export const JEEP = 'Jeep';
export const KIA = 'Kia';
export const LAMBORGHINI = 'Lamborghini';
export const LAND_ROVER = 'Land_Rover';
export const LEXUS = 'Lexus';
export const LINCOLN = 'Lincoln';
export const LOTUS = 'Lotus';
export const MAZDA = 'Mazda';
export const MASERATI = 'Maserati';
export const MAYBACH = 'Maybach';
export const MCLAREN = 'McLaren';
export const MERCEDES_BENZ = 'Mercedes-Benz';
export const MERCURY = 'Mercury';
export const MINI = 'Mini';
export const MITSUBISHI = 'Mitsubishi';
export const NISSAN = 'Nissan';
export const OLDSMOBILE = 'Oldsmobile';
export const PANOZ = 'Panoz';
export const PLYMOUTH = 'Plymouth';
export const POLESTAR = 'Polestar';
export const PONTIAC = 'Pontiac';
export const PORSCHE = 'Porsche';
export const RAM = 'Ram';
export const RIVIAN = 'Rivian';
export const ROLLS_ROYCE = 'Rolls_Royce';
export const SAAB = 'Saab';
export const SATURN = 'Saturn';
export const SMART = 'Smart';
export const SUSUKI = 'Susuki';
export const TESLA = 'Tesla';
export const TOYOTA = 'Toyota';
export const VOLKSWAGEN = 'Volkswagen';
export const VOLVO = 'Volvo';

export const ALL_CAR_MAKES = [
  ACURA,
  ALFA_ROMEO,
  ASTON_MARTIN,
  AUDI,
  BMW,
  BENTLEY,
  BUICK,
  CADILLAC,
  CHEVROLET,
  CHRYSLER,
  DAEWOO,
  DAIHATSU,
  DODGE,
  EAGLE,
  FERRARI,
  FIAT,
  FORD,
  FREIGHTLINER,
  GMC,
  GENESIS,
  GEO,
  HONDA,
  HUMMER,
  INFINITI,
  ISUZU,
  JAGUAR,
  JEEP,
  KIA,
  LAMBORGHINI,
  LAND_ROVER,
  LEXUS,
  LINCOLN,
  LOTUS,
  MAZDA,
  MASERATI,
  MAYBACH,
  MCLAREN,
  MERCEDES_BENZ,
  MERCURY,
  MINI,
  MITSUBISHI,
  NISSAN,
  OLDSMOBILE,
  PANOZ,
  PLYMOUTH,
  POLESTAR,
  PONTIAC,
  PORSCHE,
  RAM,
  RIVIAN,
  ROLLS_ROYCE,
  SAAB,
  SATURN,
  SMART,
  SUSUKI,
  TESLA,
  TOYOTA,
  VOLKSWAGEN,
  VOLVO,
];

// Models constants
export const CL = 'CL';
export const RLX = 'RLX';
export const ILX = 'ILX';
export const TLX = 'TLX';
export const INTEGRA = 'INTEGRA';
export const LEGEND = 'LEGEND';
export const MDX = 'MDX';
export const TL = 'TL';

export const MAKE = 'MAKE';
export const MODEL = 'MODEL';
export const YEAR = 'YEAR';
export const COLOR = 'COLOR';

export const MAKE_LABEL = 'Select Make';
export const MODEL_LABEL = 'Select Model';
export const YEAR_LABEL = 'Select Year';
export const COLOR_LABEL = 'Color';

// Form Control Auto Financing Style
export const VEHICLE_INFO_MAKE_MODEL_STYLE = {
  mt: 1,
  mr: 1,
  mb: 1,
  ml: 0,
  minWidth: 120,
  border: 0,
  width: '95%',
  maxWidth: 210,
};
